import React, { useState, useMemo } from 'react';
import styles from './KeymastersPotTabs.module.scss';
import YourRewardsTab from './YourRewards';
import HistoryTab from './History/History';

// This component is used in KeymastersPotView.jsx
export default function KeymastersPotTabs({ history, keys, claim, vault, setLoading, paused }) {

	const onClickClaim = async ( keysToBeClaimed ) => {
		try {
			setLoading( true );
			if ( !Array.isArray( keysToBeClaimed ) ) throw new Error( 'onClickClaim: expected Array' );
			if ( keysToBeClaimed.some( x => typeof x !== 'number' ) ) throw new Error( 'onClickClaim: expected Array to contain numbers' );
			// await claim( keysToBeClaimed, vault );
			const tx = await claim( keysToBeClaimed, vault );
			await tx.wait();
		// TODO: show success message
		} catch ( e ) {
			if ( e.reason && e.reason === 'execution reverted: Nothing to claim' ) alert( 'Nothing to claim' );
		} finally {
			setLoading( false );
		}
	};

	// TODO: change from this tabs approach, it's breaking reactivity
	// TODO: remove useMemo
	const tabs = useMemo( () => {
		return [
			{
				title: 'Your rewards',
				content: YourRewardsTab,
				props: {
					keys, // this will be replaced with data fetched from the api
					onClickClaim,
				},
			},
			{
				title: 'History',
				content: HistoryTab,
				props: {
					history, // this will be replaced with data fetched from the api
				},
			},
		];
	}, [keys, onClickClaim, history]);

	const [selectedTab, setSelectedTab] = useState( tabs[0]);


	const tabsTitle = tabs.map( ( tab ) => tab.title );
	const SelectedTabContent = selectedTab.content;



	return (
		<div className="w-full h-auto">
			<div className="flex justify-center">
				{tabsTitle.map( ( title, index ) => {
					const isSelected = selectedTab.title === title;
					return <h2 key={title}
						onClick={() => setSelectedTab( tabs[index])}
						className={`${index === 0 ? 'mr-6' : ''} text-[#1d2908] cursor-pointer uppercase max-[350px]:text-[16px]  ${styles['keymasters-pot-tabs-header']} ${isSelected ? styles['keymasters-pot-tabs-header-selected'] : ''}`}>
						{title}
					</h2>;
				})}
			</div>
			<div className='w-full h-auto'>
				<SelectedTabContent {...selectedTab.props}
					keys={keys}
					onClickClaim={onClickClaim}
					history={history}
					paused={paused}
				/>
			</div>
		</div>
	);
}
